// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__1eE8R","adsImg":"Card_adsImg__AQsaP"};